<template>
  <div
    :class="
      paymentOption === 'BB'
        ? 'option-active rounded-lg'
        : 'option-deactive rounded-lg'
    "
    @click="selectPayment('BB')"
  >
    <v-row class="py-4 px-6" no-gutters align="center">
      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
        <path
          fill="#656565"
          d="M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z"
        />
      </svg>
      <v-col cols="8" class="pl-8">
        <v-row no-gutters>
          <span class="accent--text">{{ $t("payment.billet.title") }}</span>
        </v-row>
        <v-row no-gutters>
          <span class="checkout-h4 grey--text">
            {{
              eventDetails?.prazo_pagamento_site_boleto === 1 ||
              !eventDetails?.prazo_pagamento_site_boleto
                ? $t("payment.oneParcelBillet")
                : `Pague em até ${eventDetails?.prazo_pagamento_site_boleto} dias`
            }}
          </span>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-radio-group class="pa-0 ma-0" hide-details :value="paymentOption">
        <v-radio color="primary" id="BB" value="BB"></v-radio>
      </v-radio-group>
    </v-row>
    <div class="px-4" v-if="paymentOption === 'BB'">
      <v-row no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          buyer &&
          (buyer.typeDocument === "CPF" || buyer.typeDocument === "cpf")
            ? $t("payment.billet.fullName")
            : $t("payment.billet.corporateName")
        }}</span>
      </v-row>
      <v-row no-gutters>
        <v-text-field
          outlined
          class="rounded-lg"
          :rules="[rulesValidation.required]"
          v-model="billet.payer_name"
          @input="changeInput"
        ></v-text-field>
      </v-row>
      <v-row
        v-if="
          paymentDetails &&
          paymentDetails.billet_max_installments &&
          paymentDetails.billet_max_installments > 1
        "
        class="mt-n2"
        no-gutters
      >
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("general.installments")
        }}</span>
      </v-row>
      <v-select
        v-if="
          paymentDetails &&
          paymentDetails.billet_max_installments &&
          paymentDetails.billet_max_installments > 1
        "
        outlined
        class="pr-1 custom-text rounded-lg"
        :items="itemsInstallmentsBillet"
        v-model="billet.installment_amount"
        :rules="[rulesValidation.required]"
        @change="changeInput"
      ></v-select>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row class="mt-n2" no-gutters>
            <span class="checkout-h3 accent--text" style="font-weight: 400">{{
              $t("general.document")
            }}</span>
          </v-row>
          <v-select
            outlined
            class="rounded-lg"
            :items="documents"
            v-model="billet.typeDocument"
            :rules="[rulesValidation.required]"
            @change="changeInput"
          ></v-select>
        </v-col>
        <v-col cols="12">
          <v-row class="mt-n2" no-gutters>
            <span class="checkout-h3 accent--text" style="font-weight: 400">{{
              $t("general.number")
            }}</span>
          </v-row>
          <v-text-field
            v-if="billet.typeDocument === 'cpf'"
            outlined
            class="rounded-lg"
            v-model="billet.payer_doc"
            v-mask="'###.###.###-##'"
            :rules="cpfRules"
            @input="changeInput"
          ></v-text-field>
          <v-text-field
            v-else
            outlined
            label="Número"
            class="rounded-lg"
            v-model="billet.payer_doc"
            v-mask="'##.###.###/####-##'"
            :rules="cnpjRules"
            @input="changeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-4" no-gutters>
        <v-btn
          v-if="!loading"
          width="100%"
          rounded
          depressed
          color="primary"
          :disabled="!canPurchase || !paymentOption"
          height="40"
          @click="$emit('purchase')"
          >{{ $t("summary.confirm") }}</v-btn
        >
      </v-row>
    </div>
  </div>
</template>

<script>
import validationMixin from "../../../mixins/validationMixin.vue";
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Vue from "vue";
export default {
  mixins: [validationMixin],
  directives: { mask },
  props: ["productsTotal", "loading"],
  data() {
    return {
      documents: [
        { text: "CPF", value: "cpf" },
        { text: "CNPJ", value: "cnpj" },
      ],
      billet: {
        typeDocument: "cpf",
        installment_amount: 1,
      },
    };
  },
  computed: {
    ...mapGetters([
      "paymentOption",
      "paymentDetails",
      "buyer",
      "canPurchase",
      "orderAmount",
      "eventDetails",
    ]),
    itemsInstallmentsBillet() {
      if (
        this.paymentDetails &&
        this.paymentDetails.billet_max_installments &&
        this.paymentDetails.billet_max_installments > 1
      ) {
        let array = [];

        let totalValue = 0;

        if (this.$route.query.order_hash) totalValue = this.orderAmount;
        else totalValue = this.productsTotal;

        for (let i = 0; i < this.paymentDetails.billet_max_installments; i++) {
          let string = totalValue / (i + 1);
          array.push({
            text: `${i + 1}x de ${Vue.options.filters.currency(string)}`,
            value: i + 1,
          });
        }
        return array;
      } else return [];
    },
  },
  watch: {
    paymentOption(v) {
      if (v && v === "BB") this.setModels();
    },
    billet(v) {
      if (v) this.$store.commit("SET_BUYER_DATA", { ...this.buyer, ...v });
    },
  },
  methods: {
    setModels() {
      if (this.buyer && this.buyer.customer_name)
        this.billet.payer_name = this.buyer.customer_name;
      if (this.buyer && this.buyer.typeDocument)
        this.billet.typeDocument = this.buyer.typeDocument.toLowerCase();
      if (this.buyer && this.buyer.customer_doc)
        this.billet.payer_doc = this.buyer.customer_doc;
      this.$store.commit("SET_BUYER_DATA", {
        ...this.buyer,
        ...this.billet,
      });
    },
    changeInput() {
      this.$store.commit("SET_BUYER_DATA", { ...this.buyer, ...this.billet });
    },
    selectPayment(billet) {
      this.$store.dispatch("setPaymentOption", billet);
    },
  },
};
</script>
